export const environment = {
  production: false,
  baseUrl: "https://kobize.dev.bdomobile.com",
  apiUrl: "https://server.dev.bdomobile.com",
  accountsApiUrl: "https://server.dev.bdomobile.com/accounts",
  authApiUrl: "https://server.dev.bdomobile.com/uaa",
  keycloakUrl: "https://keycloak-dev.mobiletract.com",
  adminPanelUrl: "https://admin.dev.bdomobile.com",
  platformWebUrl: "https://platforma.dev.bdomobile.com",
  webPanelUrl: "https://panel.dev.bdomobile.com",
  realm: "bdo-dev",
  clientId: "ekowitryna_kobize_web",
  googleTagManagerId: 'GTM-XXXXXX',
  googleTagManagerPreview: 'env-3',
  googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw',
  bypassAuth: false
};
